// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3tI5Y","signatureBlock":"Footer_signatureBlock__3YbeJ","signature":"Footer_signature__3BrCw"};